export interface SelectOption {
    text: string;
    value: any;
}
export enum CONTENT_TYPES {
    HOME_CARDS='home_cards'
 
}

